import { cn } from './cn';
import ContactCardNameRowPure from './ContactCardNameRowPure';
import ContactCardOrgRowPure, { type ContactCardOrgRowOrg } from './ContactCardOrgRowPure';

type ContentViewedCardBodyPureProps = {
  name: string;
  honorificTitle?: string | null;
  liOpenLink?: boolean | null;
  /** Whether the contact is a 1st-degree LinkedIn connection. Hides the InMail icon when true. */
  liConnected?: boolean | null;
  disqualified?: boolean;
  title?: string;
  org: ContactCardOrgRowOrg | null;
  documentTitle: string;
  className?: string;
};

export default function ContentViewedCardBodyPure({
  name,
  honorificTitle,
  liOpenLink,
  liConnected,
  disqualified,
  title,
  org,
  documentTitle,
  className,
}: ContentViewedCardBodyPureProps) {
  return (
    <div className={cn('flex w-0 shrink grow flex-col justify-between text-slate-800 dark:text-white', className)}>
      <div className="flex justify-between gap-1.5 overflow-hidden">
        <div className="flex w-0 grow flex-col gap-1.5">
          <ContactCardNameRowPure
            name={name}
            honorificTitle={honorificTitle}
            liOpenLink={liOpenLink}
            liConnected={liConnected}
            disqualified={disqualified}
          />
          <ContactCardOrgRowPure orgName={org?.name} orgPictureUrl={org?.pictureUrl} title={title} />
        </div>
      </div>

      <div className="flex min-h-4.5 gap-0.5 overflow-hidden">
        <div className="rounded-xs px-1.5 py-0.5 bg-indigo-100 text-xs tracking-tight text-indigo-700 dark:bg-indigo-800 dark:text-white truncate">
          {documentTitle}
        </div>
      </div>
    </div>
  );
}
